module.exports = __webpack_public_path__ + "static/media/icon-event__guerra-civil-espanola-hover.dca4f14b.svg";